import type { Schema } from '@/api/client'

export type Thresholds = Schema<'QualityThresholdsOut'>

/** The three numeric limits, with the bounds `QualityThresholdsIn` enforces. */
export const LIMITS = [
  {
    name: 'max_similarity_pct',
    label: 'Most it may repeat your own pages',
    help: 'Per cent, 1 to 30. Lower is stricter. Above this the draft is blocked as duplicate.',
    min: 1,
    max: 30,
  },
  {
    name: 'max_unverifiable_claims',
    label: 'Claims allowed with no source',
    help: '0 to 3. A citation that does not resolve blocks the draft whatever this is set to.',
    min: 0,
    max: 3,
  },
  {
    name: 'min_eeat_score',
    label: 'Trust score it must reach',
    help: '40 to 100. Experience, expertise, authority and trust — author attribution, sources, first-hand detail.',
    min: 40,
    max: 100,
  },
] as const

export type LimitName = (typeof LIMITS)[number]['name']
export type Limit = (typeof LIMITS)[number]

/** The form's draft: each limit as typed, so "empty" stays distinguishable from zero. */
export type ThresholdsDraft = Record<LimitName, string> & { block_avoided_words: boolean }

export function draftOf(stored: Thresholds): ThresholdsDraft {
  return {
    max_similarity_pct: String(stored.max_similarity_pct),
    max_unverifiable_claims: String(stored.max_unverifiable_claims),
    min_eeat_score: String(stored.min_eeat_score),
    block_avoided_words: stored.block_avoided_words,
  }
}

/** The sentence under a limit whose draft is not a whole number in range, or `undefined`. */
export function limitError(limit: Limit, raw: string): string | undefined {
  const value = Number(raw)
  if (raw.trim() === '' || !Number.isInteger(value) || value < limit.min || value > limit.max) {
    return `A whole number between ${String(limit.min)} and ${String(limit.max)}.`
  }
  return undefined
}

export function bodyOf(draft: ThresholdsDraft): Schema<'QualityThresholdsIn'> {
  return {
    max_similarity_pct: Number(draft.max_similarity_pct),
    max_unverifiable_claims: Number(draft.max_unverifiable_claims),
    min_eeat_score: Number(draft.min_eeat_score),
    block_avoided_words: draft.block_avoided_words,
  }
}
